import { render, staticRenderFns } from "./form-transformations.vue?vue&type=template&id=548c367c&scoped=true"
import script from "./form-transformations.vue?vue&type=script&lang=js"
export * from "./form-transformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548c367c",
  null
  
)

export default component.exports